import withLocationSelectionForm from '../hoc/withLocationSelectionForm';
import withStorePublicInfo from '../hoc/withStorePublicInfo';
import withGetCompanyID from '../hoc/withGetCompanyID';
import AllRoute from './AllRoute';
import { withCreateGuestID } from '../hoc/withCreateGuestID';

const WrappedAllRoute = withCreateGuestID(
  withGetCompanyID(withLocationSelectionForm(withStorePublicInfo(AllRoute)))
);

export default WrappedAllRoute;
